import { createContext, useContext } from 'react';
import apiClient from 'hub-http/clients/apiClient';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Context for the hub-http client used by unified-auth-core-lib components.
 *
 * The default value is `hub-http/clients/apiClient`, which requires a portal
 * session. Internal tools (HubSpotter / tools-auth) that don't have a portal
 * session can wrap their tree in `HttpClientProvider` and pass a client built
 * for their auth context (e.g. via `hub-http-janus` IDP stacks).
 *
 * @example
 * import promiseClient from 'hub-http/adapters/promiseClient';
 * import { createIdpAuthStack } from 'hub-http-janus/stacks/idpAuthApi';
 * import { HttpClientProvider } from 'unified-auth-core-lib';
 *
 * const internalClient = promiseClient(createIdpAuthStack(toolsApi));
 *
 * <HttpClientProvider httpClient={internalClient}>
 *   <UnifiedAuthButton ... />
 * </HttpClientProvider>
 */
export const HttpClientContext = /*#__PURE__*/createContext(apiClient);
export const useHttpClient = () => useContext(HttpClientContext);
export function HttpClientProvider({
  httpClient = apiClient,
  children
}) {
  return /*#__PURE__*/_jsx(HttpClientContext.Provider, {
    value: httpClient,
    children: children
  });
}